import { Component, Input, NgZone } from '@angular/core';
import { AlertController, NavController, NavParams, Events } from 'ionic-angular';
import { Storage } from '@ionic/storage';
import { PhotoViewer } from '@ionic-native/photo-viewer';
import * as Clipboard from 'clipboard/dist/clipboard.min.js';
//import { Clipboard } from '@ionic-native/clipboard';

import { TasksDetailComponent } from '../tasks-detail/tasks-detail';
import { TasksCommentComponent } from '../tasks-comment/tasks-comment';
import { PublicPage } from '../../pages/public/public';
import { AccountSignupPage } from '../../pages/account-signup/account-signup';

import { Task } from '../../providers/task';
import { User } from '../../providers/user';

@Component({
  selector: 'tasks',
  templateUrl: 'tasks.html',
  providers: [PhotoViewer]
})

export class TasksComponent {
  @Input() tasks: any = [];
  @Input() profile: any = {};
  @Input() photo64: string;
  busy: boolean = true;
  blank: string = 'assets/img/user-blank.svg';
  clipboard: any;
  dataAvailable: boolean = true;
  firstname: string = '';

  @Input() entry: any = {
    id: false,
    title: '',
    time: '', // h:m
    amount: '',
    transfer: 'false',
    nights:'',
    link: '',
    likes: [],
  };

  constructor(
    public events: Events,
    public nav: NavController,
    public user: User,
    public alert: AlertController,
    public navParams: NavParams,
    public storage: Storage,
    public zone: NgZone,
    public task: Task,
    public photoViewer: PhotoViewer
  ) {
    debugger;
    user.isNotConnected().then((user) => {
      debugger;
      if (user) {
        this.nav.setRoot(AccountSignupPage);
      }
    });
    
    this.events.subscribe('task:saved', (t) => {
      this.profile = this.user.profile();
      if(this.profile ){
        this.firstname = this.profile.displayName;
        this.bootstrap();
      }
    });
    this.events.subscribe('user:loggedIn', () => {
      this.profile = this.user.profile();
      if(this.profile ){
        this.firstname = this.profile.displayName;
        this.bootstrap();
      }
    });
    
    this.profile = this.user.profile();
      if(this.profile ){
        this.firstname = this.profile.displayName;
        this.bootstrap();
      }

    //this.firstname = this.user.profile().displayName;
    this.clipboard = new Clipboard("#cpyBtn");
    this.clipboard.on('success', () => console.log('saved to clipboard'));
  }

  ionViewDidLoad() {
      this.profile = this.user.profile();
      if(this.profile ){
        this.firstname = this.profile.displayName;
        this.bootstrap();
      }
  }

  ionViewDidEnter() {
      this.profile = this.user.profile();
      if(this.profile ){
        this.firstname = this.profile.displayName;
        this.bootstrap();
      }
  }

  bootstrap() {
    this.busy = true;
    console.info('task:bootstrap');
    // try to load from Network
    this.task.ref().then((path) => {
      console.info('task:bootstrap:path: '+path);
      this.task.db().ref(path).on('value', (snapshot) => {
        let tasks: any = this.task.prepare(snapshot);
        var j  =  JSON.parse(JSON.stringify(snapshot));
        this.zone.run(() => { // workaround to get it updated instantly on the view
          this.tasks = tasks; // set to view
          this.task.persist(tasks);
          this.busy = false;
          debugger;
          if(tasks != undefined && !tasks.length)
            this.dataAvailable = false;
          else
            this.dataAvailable = true;
            //this.nav.push(TasksDetailComponent);
        });
      }, (e) => { this.busy = false; console.info('task:bootstrap:error'); debugger; console.debug(e); });
    }, (e) => { this.busy = false; console.info('task:bootstrap:error'); debugger; console.debug(e); });

    // try to load itens from cache after 10 seconds, user can maybe be offline or running with slow connection
    setTimeout(() => {
      //this.busy = true;
      this.loadOffline();
    }, 10000);
  }

  loadOffline() {
    if (!this.tasks.length)
    {
      try {
        this.storage.get('firetask:task').then((t) => {
          let tasks = JSON.parse(t);
          
          if (tasks != null && tasks.length)
            this.tasks = tasks;
            //debugger;
            if(this.tasks.length > 0)
              this.dataAvailable = true;
        });
      } catch (e) { };
    }
  }

  formatDate(dateString)
  {
    var monthNames = [
      "January", "February", "March",
      "April", "May", "June", "July",
      "August", "September", "October",
      "November", "December"
    ];

    var date = new Date(dateString);
    var day = date.getDate();
    var monthIndex = date.getMonth();
    var year = date.getFullYear();

    return day + ' ' + monthNames[monthIndex] + ' ' + year;
  }

  onPictureClick(event: Event, task:any)
  {
    event.preventDefault();
    event.stopPropagation();
    this.photoViewer.show(task.file, task.title, {share: true});
  }

  numberOfLikes( likes: any)
  {
    if(likes != undefined)
    {
      //alert(JSON.stringify(likes));
      try
      {
        return likes.length;
      }
      catch(dd)
      {
        alert(dd); 
        return 0;
      }
    }
    else
    {
      return 0;
    }
  }

  numberOfComments(comments: any)
  {
    if(comments != undefined)
    {
      //alert(JSON.stringify(comments));
      try
      {
        return comments.length;
      }
      catch(dd)
      {
        alert(dd); 
        return 0;
      }
    }
    else
    {
      return 0;
    }
  }

  delete(task) {
    let confirm = this.alert.create({
      title: 'Delete "' + task.title + '"?',
      message: 'Sure you want to delete? It can not be undone.',
      buttons: [
        {
          text: 'Cancel',
          handler: () => { }
        },
        {
          text: 'Ok',
          handler: () => {

            this.task.remove(task.id)
              .then(() => {
                console.info(`task ${task.title} removed`);
                this.task.persist(this.tasks);
              })
              .catch((e) => {
                console.error(e);
              });

          }
        }
      ]
    });
    setTimeout(() => confirm.present());
  }


timeSince(time: any) {
  //console.info(time);
  if(time != undefined)
  {
    switch (typeof time) {
      case 'number':
        break;
      case 'string':
        time = +new Date(time);
        break;
      case 'object':
        if (time.constructor === Date) time = time.getTime();
        break;
      default:
        time = +new Date();
    }
    var time_formats = [
      [60, 'seconds', 1], // 60
      [120, '1 minute ago', '1 minute from now'], // 60*2
      [3600, 'minutes', 60], // 60*60, 60
      [7200, '1 hour ago', '1 hour from now'], // 60*60*2
      [86400, 'hours', 3600], // 60*60*24, 60*60
      [172800, 'Yesterday', 'Tomorrow'], // 60*60*24*2
      [604800, 'days', 86400], // 60*60*24*7, 60*60*24
      [1209600, 'Last week', 'Next week'], // 60*60*24*7*4*2
      [2419200, 'weeks', 604800], // 60*60*24*7*4, 60*60*24*7
      [4838400, 'Last month', 'Next month'], // 60*60*24*7*4*2
      [29030400, 'months', 2419200], // 60*60*24*7*4*12, 60*60*24*7*4
      [58060800, 'Last year', 'Next year'], // 60*60*24*7*4*12*2
      [2903040000, 'years', 29030400], // 60*60*24*7*4*12*100, 60*60*24*7*4*12
      [5806080000, 'Last century', 'Next century'], // 60*60*24*7*4*12*100*2
      [58060800000, 'centuries', 2903040000] // 60*60*24*7*4*12*100*20, 60*60*24*7*4*12*100
    ];
    var seconds = (+new Date() - time) / 1000,
      token = 'ago',
      list_choice = 1;

    if (seconds == 0) {
      return 'Just now'
    }
    if (seconds < 0) {
      seconds = Math.abs(seconds);
      token = 'from now';
      list_choice = 2;
    }
    var i = 0,
      format;
    while (format = time_formats[i++])
      if (seconds < format[0]) {
        if (typeof format[2] == 'string')
          return format[list_choice];
        else
          return Math.floor(seconds / format[2]) + ' ' + format[1] + ' ' + token;
      }
    return time;
  }
  else
  {
    return 'NAN';
  }
}


  addTask(t) {
    let tasks = this.tasks;
    this.tasks = tasks;
  }

  onDetail(data?: any) {
    this.nav.push(TasksDetailComponent, data);
  }

  onComment(event: Event, data?: any) {
    event.preventDefault();
    event.stopPropagation();
    this.nav.push(TasksCommentComponent, data);
  }

  onCopy(event: Event, data?: any) {
    event.preventDefault();
    event.stopPropagation();

  }

  onOpenPublic(event: Event, data?: any) {
    event.preventDefault();
    event.stopPropagation();
    //this.nav.push(PublicPage, data);
    var win = window.open(data.tinyurl, '_blank');
    win.focus();
  }
  
  addVoucher() {
    this.nav.push(TasksDetailComponent);
  }

  onLike(event: Event, entry?: any) {
    event.preventDefault();
    console.info(JSON.stringify(this.user.profile()));
    if(entry.likes == undefined)
      entry.likes = [];
    entry.likes.indexOf(this.user.profile().email) === -1 ? entry.likes.push(this.user.profile().email) : entry.likes.pop(this.user.profile().email);
    this.task
        .save(entry)
        .then(() => {
          console.info(`task ${entry.title} saved`);
        }).catch((e) => { console.error(e); });
  }

}


// WEBPACK FOOTER //
// ./src/components/tasks/tasks.ts